import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import { AuthProvider } from "./contexts/AuthContext";
import { CompareProvider } from "./contexts/CompareContext";

const Services = lazy(() => import("./pages/Services"));
const SpmSolutions = lazy(() => import("./pages/SpmSolutions"));
const PowerElectronics = lazy(() => import("./pages/PowerElectronics"));
const Brands = lazy(() => import("./pages/Brands"));
const Industries = lazy(() => import("./pages/Industries"));
const ServiceAreas = lazy(() => import("./pages/ServiceAreas"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const RequestQuote = lazy(() => import("./pages/RequestQuote"));
const ThankYou = lazy(() => import("./pages/ThankYou"));
const Legal = lazy(() => import("./pages/Legal"));
const HtmlSitemap = lazy(() => import("./pages/HtmlSitemap"));
const DynamicPage = lazy(() => import("./pages/DynamicPage"));
const NotFound = lazy(() => import("./pages/NotFound"));
const MarketplaceBrowse = lazy(() => import("./pages/MarketplaceBrowse"));
const MachineDetail = lazy(() => import("./pages/MachineDetail"));
const WantedAds = lazy(() => import("./pages/WantedAds"));
const Sell = lazy(() => import("./pages/Sell"));
const AuthPage = lazy(() => import("./pages/AuthPage"));
const SellerDashboard = lazy(() => import("./pages/SellerDashboard"));
const AddMachine = lazy(() => import("./pages/AddMachine"));
const ComparePage = lazy(() => import("./pages/ComparePage"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));
const AdminMachineEdit = lazy(() => import("./pages/AdminMachineEdit"));

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
      <CompareProvider>
      <Layout>
        <Suspense fallback={<div className="min-h-[60vh] bg-slate-950" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/machines" element={<MarketplaceBrowse />} />
            <Route path="/used-cnc-vmc" element={<MarketplaceBrowse />} />
            <Route path="/used-cnc-lathe" element={<MarketplaceBrowse />} />
            <Route path="/used-injection-moulding-machines" element={<MarketplaceBrowse />} />
            <Route path="/used-industrial-presses" element={<MarketplaceBrowse />} />
            <Route path="/used-industrial-robots" element={<MarketplaceBrowse />} />
            <Route path="/used-packaging-machines" element={<MarketplaceBrowse />} />
            <Route path="/used/:category" element={<MarketplaceBrowse />} />
            <Route path="/used/:category/:subcategory" element={<MarketplaceBrowse />} />
            <Route path="/machine/:id" element={<MachineDetail />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/wanted" element={<WantedAds />} />
            <Route path="/sell" element={<Sell />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route path="/seller/dashboard" element={<SellerDashboard />} />
            <Route path="/seller/add-machine" element={<AddMachine />} />
            <Route path="/seller/machines/:id/edit" element={<AddMachine />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/machines/:id/edit" element={<AdminMachineEdit />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<DynamicPage />} />
            <Route path="/spm-solutions" element={<SpmSolutions />} />
            <Route path="/spm-solutions/:slug" element={<DynamicPage />} />
            <Route path="/power-electronics" element={<PowerElectronics />} />
            <Route path="/power-electronics/:slug" element={<DynamicPage />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/brands/:slug" element={<DynamicPage />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/industries/:slug" element={<DynamicPage />} />
            <Route path="/service-areas" element={<ServiceAreas />} />
            <Route path="/service-areas/:slug" element={<DynamicPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/request" element={<RequestQuote />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/privacy-policy" element={<Legal type="privacy" />} />
            <Route path="/terms-of-service" element={<Legal type="terms" />} />
            <Route path="/legal/trademarks" element={<Legal type="trademarks" />} />
            <Route path="/sitemap" element={<HtmlSitemap />} />
            <Route path="/:slug" element={<DynamicPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </Layout>
      </CompareProvider>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
